import { useMutation } from "react-query";
import { CreateConnectionProps } from "../../types/link";
import { createConnection } from "../apis/integrations";

export const useCreateConnection = () => {
  const mutation = useMutation(
    ({
      authForm,
      connectionDefinitionId,
      linkHeaders,
      requestId,
    }: CreateConnectionProps) =>
      createConnection({
        authForm,
        connectionDefinitionId,
        linkHeaders,
        requestId,
      })
  );

  return {
    createIntegration: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
  };
};
